export default "<div class=\"dialog-entry\">\n    <ng-content></ng-content>\n</div>\n";